<template>
  <div>
    <PPHeader>
      <b-img
        :src="pageConfig.banner"
        @error="pageConfig.showBanner = false"
        fluid-grow
        center
        style="max-width: 430px; max-height: 60px"
      />
    </PPHeader>
    <b-container class="justify-content-center">
      <PaymentError
        v-if="pageConfig.transactionError"
        :error="pageConfig.transactionError"
        :dismissible="pageConfig.paymentErrorDismissible"
      />
      <b-row v-show="sectionDisplay.showPaymentForm">
        <b-col>
          <b-form @submit.prevent="onSubmit" @reset.prevent="reset">
            <div
              v-if="this.paymentConfig.returnToMerchantUrl"
              class="ml-6 mb-2"
            >
              <v-btn elevation="1" medium @click="backToMerchant">
                <v-icon left>arrow_back</v-icon>
                Back
              </v-btn>
            </div>
            <KTPortlet>
              <template v-slot:body>
                <h4>Recurring Payment Information</h4>
                <br />
                <RecurringPaymentInfo v-bind="recurringInfoObject" />
                <br />
                <hr />

                <br />

                <h4>Order Information</h4>
                <OrderInfo
                  :errorMessages="errorMessages.orderInformation"
                  :orderInformationReadOnly="
                    pageConfig.orderInformationReadOnly
                  "
                  :cols-sm="pageConfig.numberOfColumnsForOrderInformation"
                  cols="1"
                  v-model="$v.form.orderInformation.$model"
                />
                <div v-if="arePromocodesAvailable">
                  <br />
                  <hr />
                  <br />
                  <h4>Promotional Code</h4>

                  <Promocode
                    v-model="promoCodeDetails"
                    :amount="form.orderDetails.initialPaymentAmount"
                    :recurringAmount="amount"
                    :tenantAlias="paymentConfig.merchantId"
                    :email="form.orderInformation.email"
                    transactionType="Recurring"
                    :authenticationMode="authMode"
                    :recurringFrequency="form.recurringInformation.frequency"
                  />
                </div>

                <template v-if="customFields && customFields.length">
                  <br />
                  <hr />
                  <br />

                  <h4>Additional Information</h4>
                  <FormGenerator
                    :formProperties="customFields"
                    v-model="form.customFieldsModel"
                    :cols-sm="pageConfig.numberOfColumnsForCustomFields"
                    cols="1"
                  />
                </template>

                <br />
                <hr />
                <br />

                <h4>Billing Information</h4>
                <BillingInfo
                  :errorMessages="errorMessages.billingInfo"
                  :filter="billingInfoFilter"
                  :countries="lists.countries"
                  :states="lists.states"
                  v-model="$v.form.billingInfo.$model"
                />

                <br />
                <hr />
                <br />

                <h4>Credit Card Information</h4>
                <CreditCardInfo
                  :errorMessages="errorMessages.creditCardInfo"
                  :typeList="lists.cardTypes"
                  :cNumberLength="creditCardLength"
                  v-model="$v.form.creditCardInfo.$model"
                />

                <br />
                <hr />
                <br />

                <ServiceAgreement
                  :documentPath="serviceAgreementDocument"
                  v-model="serviceAgreement"
                />
              </template>

              <template v-slot:foot>
                <div class="d-flex justify-content-center">
                  <b-button
                    id="pay-now"
                    type="submit"
                    variant="primary"
                    size="lg"
                    :disabled="!serviceAgreement"
                    >Pay Now</b-button
                  >
                </div>
              </template>
            </KTPortlet>
          </b-form>
        </b-col>
      </b-row>
      <b-row v-show="sectionDisplay.showConfirmationPage">
        <b-col>
          <RecurringPaymentReview
            :promoCodeDetails="promoCodeDetails"
            v-if="sectionDisplay.showConfirmationPage"
            :form="paymentReviewData"
            :customFields="customFields"
            @confirm="confirm"
            @back="back"
          />
        </b-col>
      </b-row>
      <b-row class="justify-content-center"
        ><p style="font-size: 14px">powered by PAYNOWPRO</p></b-row
      >
      <b-row align-h="around" v-show="sectionDisplay.showPaymentForm">
        <b-col cols="2">
          <b-img :src="pageConfig.codeimpleImage" fluid-grow />
        </b-col>
        <b-col cols="2" class="img_container">
          <b-img :src="pageConfig.masterCardImage" fluid-grow class="pay_img" />
        </b-col>
        <b-col cols="2" class="img_container">
          <b-img :src="pageConfig.visaImage" fluid-grow class="pay_img" />
        </b-col>
        <b-col cols="2" class="img_container">
          <b-img :src="pageConfig.facImage" fluid-grow class="pay_img" />
        </b-col>
      </b-row>
      <div v-if="facHtmlForm" v-html="facHtmlForm" />

      <LoadingModal v-bind="loadingModal" />
      <AlertModal
        v-bind="alertModal"
        v-model="alertModal.show"
        @dismiss="resetAlert"
      />
      <ConfirmationModal
        v-bind="confirmationModal"
        v-model="confirmationModal.show"
        @dismiss="resetConfirmation"
      />
    </b-container>
  </div>
</template>

<script>
import PPHeader from "@/components/payment/PaymentPageHeader.vue";
import OrderInfo from "@/components/payment/OrderInfo.vue";
import CurrencyMixin from "@/components/payment/CurrencyMixin.js";
import BillingInfo from "@/components/payment/BillingInfo.vue";
import CreditCardInfo from "@/components/payment/CreditCardInfo.vue";
import RecurringPaymentInfo from "@/components/recurringpayment/RecurringPaymentInfo.vue";
import FormGenerator from "@/components/form-elements/generators/FormGenerator.vue";
import RecurringPaymentReview from "@/components/recurringpayment/RecurringPaymentReview.vue";
import KTPortlet from "@/views/partials/content/Portlet";
import ServiceAgreement from "@/components/service-agreement/ServiceAgreement.vue";
import PaymentError from "@/components/payment/PaymentError.vue";
import AlertModalMixin from "@/components/widgets/AlertModalMixin.js";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import PaymentValidationMixin from "@/components/payment/PaymentValidationMixin.js";
import PaymentDiscountMixin from "@/components/payment/PaymentDiscountMixin.js";
import Promocode from "@/components/payment/Promocode.vue";
import PromocodeMixin from "@/components/payment/PromocodeMixin";
import {
  determineMasterCardDiscount,
  extractZoneFromOrderNumber
} from "@/services/MerchantSiteInteractionService.js";
import { Storage, API, graphqlOperation } from "aws-amplify";
import {
  CLEAR_PAYMENT_CONFIG,
  CLEAR_TRANSACTION_ERROR,
  SET_COMING_FROM_RECEIPT_PAGE_TO_FALSE
} from "@/store/payment.module";
import AppSettings from "@/appsettings/appsettings.js";

const parseToFloat = PaymentValidationMixin.parseToFloat;

const masterCardImage = "/assets/media/logos/mc_seccode_png.png";
const visaImage = "/assets/media/logos/verified-by-visa.png";
const facImage = "/assets/media/logos/powered-fac.gif";
const codeimpleImage = "/assets/media/logos/codeimple.png";

const AlertModal = AlertModalMixin.AlertModal;
const LoadingModal = AlertModalMixin.LoadingModal;

const SECTION = {
  PAYMENTFORM: "showPaymentForm",
  CONFIRMATIONPAGE: "showConfirmationPage"
};

const LOADING_MODAL_DEFAULT_TEXT = "Processing Payment, Please Wait";

function GetBrowserInfo() {
  const n = window && window.screen ? window.screen.width : "",
    e = window && window.screen ? window.screen.height : "",
    w = window && window.screen ? window.screen.colorDepth : "",
    o = window && window.navigator ? window.navigator.userAgent : "",
    i = !(!window || !window.navigator) && navigator.javaEnabled();
  let a = "";
  return (
    window &&
      window.navigator &&
      (a = window.navigator.language
        ? window.navigator.language
        : window.navigator.browserLanguage),
    {
      screenWidth: n,
      screenHeight: e,
      colorDepth: w,
      userAgent: o,
      timeZoneOffset: new Date().getTimezoneOffset(),
      language: a,
      javaEnabled: i,
      javascriptEnabled: !0
    }
  );
}
function GetBrowserInfoAndSubmit() {
  var e = GetBrowserInfo();
  (document.getElementById("browserLanguage").value = e.language),
    (document.getElementById("browserWidth").value = e.screenWidth),
    (document.getElementById("browserHeight").value = e.screenHeight),
    (document.getElementById("browserTimeZone").value = e.timeZoneOffset),
    (document.getElementById("browserJavaEnabled").value = e.javaEnabled),
    (document.getElementById("browserJavascriptEnabled").value =
      e.javascriptEnabled),
    (document.getElementById("browserColorDepth").value = e.colorDepth),
    document.forms[1].submit();
}

export default {
  mixins: [
    PaymentValidationMixin,
    PromocodeMixin,
    PaymentDiscountMixin("amount"),
    AlertModalMixin,
    CurrencyMixin
  ],
  components: {
    Promocode,
    OrderInfo,
    BillingInfo,
    CreditCardInfo,
    RecurringPaymentInfo,
    FormGenerator,
    KTPortlet,
    RecurringPaymentReview,
    LoadingModal,
    PaymentError,
    PPHeader,
    ServiceAgreement
  },
  beforeRouteEnter(to, from, next) {
    var intentId = to.params.id;
    next(async vm => {
      if (!intentId) vm.$router.push({ name: "404" });
    });
  },
  data() {
    return {
      sectionDisplay: {
        showPaymentForm: false,
        showConfirmationPage: false
      },
      paymentConfig: {
        returnToMerchantUrl: null,
        intentId: null,
        merchantId: null,
        zone: null
      },
      pageConfig: {
        numberOfColumnsForOrderInformation: 2,
        numberOfColumnsForCustomFields: 2,
        orderInformationReadOnly: false,
        banner: null,
        showBanner: false,
        masterCardImage: masterCardImage,
        visaImage: visaImage,
        facImage: facImage,
        codeimpleImage: codeimpleImage,
        transactionError: null,
        paymentErrorDismissible: true
      },
      lists: {
        currencies: [{ value: "388", text: "JMD" }],
        countries: [],
        states: [{ value: null, text: "N/A" }],
        cardTypes: []
      },
      facHtmlForm: null,
      form: {
        customFieldsModel: {},
        orderInformation: {
          firstName: "",
          lastName: "",
          email: "",
          orderNumber: ""
        },
        orderDetails: {
          amount: 0,
          currency: "388",
          initialPaymentAmount: 0
        },
        recurringInformation: {
          period: 1,
          frequency: "",
          executionDate: null,
          reason: ""
        },
        billingInfo: {
          FirstName: "",
          LastName: "",
          Address1: "",
          Address2: "",
          City: "",
          State: "",
          ZipCode: "",
          Country: ""
        },
        creditCardInfo: {
          cnumber: "",
          cardHolderName: "",
          cvc: "",
          expiryDate: "",
          cardType: ""
        }
      },
      customFields: [],
      serviceAgreement: false,
      serviceAgreementDocument: AppSettings.recurringPaymentTOS
    };
  },
  watch: {
    cardTypeName(newValue) {
      determineMasterCardDiscount(
        newValue,
        this.paymentConfig.zone,
        this.addDiscount,
        this.removeDiscount
      );
    }
  },
  computed: {
    isComingFromReceiptPage() {
      return this.$store.getters.isComingFromReceiptPage;
    },
    transactionErrorConfig() {
      if (!this.isComingFromReceiptPage) return null;
      return this.$store.getters.transactionError;
    },
    intentWasSent() {
      return !!this.paymentConfig.intentId;
    },
    paymentReviewData() {
      const reviewData = {
        customFieldsModel: { ...this.form.customFieldsModel },
        orderInformation: { ...this.form.orderInformation },
        orderDetails: {
          ...this.form.orderDetails,
          total: this.finalAmount,
          discounts: this.discounts
        },
        billingInfo: { ...this.form.billingInfo },
        creditCardInfo: {
          ...this.form.creditCardInfo
        },
        recurringInformation: { ...this.form.recurringInformation }
      };

      reviewData.orderDetails.currency = this.currencyText;

      reviewData.billingInfo.Country = this.getCountryTextFromCode(
        this.form.billingInfo.Country
      );

      return reviewData;
    },
    recurringInfoObject() {
      return {
        recurringInfo: { ...this.form.recurringInformation },
        orderDetails: {
          ...this.form.orderDetails,
          currency: this.currencyText
        }
      };
    },
    selectedCardType() {
      return this.form.creditCardInfo.cardType;
    },
    cardTypeName() {
      if (!this.selectedCardType) return "";
      return this.selectedCardType.text;
    },
    creditCardLength() {
      return this.cardTypeObject.constraints.cardLength;
    },
    currencyText() {
      const currency = this.form.orderDetails.currency;
      if (!currency) return "";
      return this.getCurrencyTextFromCode(currency);
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    authMode() {
      return this.isAuthenticated ? null : AppSettings.UnauthenticatedAuthMode;
    },
    amount() {
      return parseToFloat(this.form.orderDetails.amount);
    }
  },
  methods: {
    backToMerchant() {
      this.clearFormConfigOnVuex();
      window.location = this.paymentConfig.returnToMerchantUrl;
    },
    async retrieveBanner() {
      const vm = this;
      Storage.get(`merchant/banner/${this.paymentConfig.merchantId}`)
        .then(async result => {
          vm.pageConfig.banner = result;
          vm.pageConfig.showBanner = true;
        })
        .catch(err => {
          vm.$logger.error(err);
          vm.pageConfig.banner = null;
        });
    },
    setDefaultDate(daysInTheFuture) {
      const d = new Date();
      d.setDate(d.getDate() + daysInTheFuture);
      return d;
    },
    getCurrencyTextFromCode(code) {
      const currencyList = this.lists.currencies;
      if (!currencyList || currencyList < 1) return "";
      const currencyIndex = currencyList.findIndex(c => c.value == code);
      return currencyIndex > -1 ? currencyList[currencyIndex].text : "";
    },
    getCountryTextFromCode(code) {
      const countryList = this.lists.countries;
      if (!countryList || countryList < 1) return "";
      const countryIndex = countryList.findIndex(c => c.value == code);
      return countryIndex > -1 ? countryList[countryIndex].text : "";
    },
    onSubmit(e) {
      e.preventDefault();
      if (!this.serviceAgreement) {
        this.alert(
          "You must accept the terms of service before proceeding",
          AlertModal.Information
        );
        return;
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.alert("Form invalid", AlertModal.WARNING);
        return;
      }

      this.showSection(SECTION.CONFIRMATIONPAGE);
    },
    async confirm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.alert("Form invalid", AlertModal.WARNING);
        this.showSection(SECTION.PAYMENTFORM);
        return;
      }
      this.startLoadingDialog(LOADING_MODAL_DEFAULT_TEXT);

      if (!this.intentWasSent) {
        const paymentIntentErrorMessage =
          "There was an error submitting your form. Please try again later. (error code: 01)";
        this.$logger.error("No payment intent id");
        this.stopLoadingDialog(paymentIntentErrorMessage, AlertModal.ERROR);
        return false;
      }

      if (this.areDiscountsApplied) {
        const discountAppliedErrorMessage =
          "There was an error submitting your form. Please try again later. (error code: 02)";
        const modifyPaymentIntentDiscountStatus = await this.modifyPaymentIntentDiscounts(
          this.discounts
        );
        const modifyPaymentIntentDiscountSuccessStatus = "UPDATED";
        if (
          !modifyPaymentIntentDiscountStatus ||
          modifyPaymentIntentDiscountStatus !==
            modifyPaymentIntentDiscountSuccessStatus
        ) {
          this.$logger.error(modifyPaymentIntentDiscountStatus);
          this.stopLoadingDialog(discountAppliedErrorMessage, AlertModal.ERROR);
          return false;
        }
      }

      const authorizationErrorMessage =
        "There was an error submitting your form. Please try again later.  (error code: 03)";

      try {
        const authorizationSuccessful = await this.authorizePayment();
        this.stopLoadingDialog();
        if (!authorizationSuccessful)
          this.alert(authorizationErrorMessage, AlertModal.ERROR);
      } catch (e) {
        this.$logger.error(e);
        this.stopLoadingDialog(authorizationErrorMessage, AlertModal.ERROR);
      }
    },
    async authorizePayment() {
      const createPaymentAuthorization = `
            mutation CreatePaymentAuthorization(
              $body: MutationCreatePaymentAuthorizationBodyInput
            ) {
              createPaymentAuthorization(body: $body) {
                htmlForm,
                errors{
                  message
                }
              }
            }
          `;
      const paymentDetails = this.generatePaymentDetails(
        this.form,
        this.paymentConfig.intentId
      );

      const authorizeResponse = await API.graphql({
        ...graphqlOperation(createPaymentAuthorization, {
          body: paymentDetails
        }),
        authMode: this.authMode
      });

      if (authorizeResponse.data.createPaymentAuthorization.errors)
        return false;

      this.facHtmlForm =
        authorizeResponse.data.createPaymentAuthorization.htmlForm;
      this.clearFormConfigOnVuex();
      this.$nextTick().then(() => {
        this.submitPaymentGatewayForm();
        this.submitPowerTranzForm();
      });
      return true;
    },
    submitPaymentGatewayForm() {
      try {
        document.getElementById("frmHtmlCheckout").submit();
      } catch (e) {
        this.$logger.error(e);
      }
    },
    submitPowerTranzForm() {
      try {
        GetBrowserInfoAndSubmit();
      } catch (e) {
        this.$logger.error(e);
      }
    },
    generatePaymentDetails(form, intentId) {
      const val = {
        returnUrl: "",
        intentId: intentId,
        customerDetail: this.generateCustomerDetails(
          this.form.orderInformation,
          this.form.customFieldsModel
        ),
        billingDetail: this.generateBillingDetails(form.billingInfo),
        cardDetail: this.generateCardDetails(form.creditCardInfo)
      };
      if (this.promoCodeDetails.success) {
        val.promotionalCode = this.promoCodeDetails.code;
      }
      return val;
    },
    generateCustomerDetails(orderInfo, customFields) {
      return {
        firstName: orderInfo.firstName,
        lastName: orderInfo.lastName,
        email: orderInfo.email,
        metaData: this.generateCustomFieldsArray(customFields)
      };
    },
    generateCustomFieldsArray(customFields) {
      let customFieldsArray = [];
      for (let fieldName in customFields) {
        if (customFields.hasOwnProperty(fieldName)) {
          customFieldsArray.push({
            name: fieldName,
            value: customFields[fieldName]
          });
        }
      }
      return customFieldsArray;
    },
    generateBillingDetails(bill) {
      return {
        address1: bill.Address1,
        address2: bill.Address2,
        postalCode: bill.ZipCode,
        firstName: bill.FirstName,
        lastName: bill.LastName,
        city: bill.City,
        state: bill.State,
        country: bill.Country
      };
    },
    generateCardDetails(card) {
      return {
        cardHolderName: card.cardHolderName,
        cardNumber: this.formatCreditCardNumber(card.cnumber),
        cardExpiryDate: this.formatExpiryDate(card.expiryDate),
        cvv: card.cvc.toString(),
        cardType: card.cardType.text
      };
    },
    back() {
      this.showSection(SECTION.PAYMENTFORM);
    },
    showSection(sectionName) {
      if (this.sectionDisplay[sectionName] === undefined) return;

      for (let key in this.sectionDisplay) {
        if (this.sectionDisplay.hasOwnProperty(key)) {
          this.sectionDisplay[key] = false;
        }
      }

      this.sectionDisplay[sectionName] = true;
    },
    formatCreditCardNumber(cardNumber) {
      return cardNumber.replace(/\D/g, "");
    },
    formatExpiryDate(exDate) {
      return exDate.replace(/\D/g, "");
    },
    reset(e) {
      e.preventDefault();

      this.form.billingInfo = {
        FirstName: "",
        LastName: "",
        Address1: "",
        Address2: "",
        City: "",
        State: "",
        ZipCode: "",
        Country: ""
      };

      this.form.creditCardInfo = {
        cnumber: "",
        cardHolderName: "",
        cvc: "",
        expiryDate: ""
      };
    },
    async loadSelectLists() {
      var vm = this;
      const tenantAlias = this.paymentConfig.merchantId;
      await this.checkCodesAvailablity(tenantAlias, this.authMode);
      const listCardTypes = `
            query GetAcquirerCardTypesByMerchant(
              $tenantAlias: String!
            ) {
              getAcquirerCardTypesByMerchant(tenantAlias: $tenantAlias) {
                name
                longName
              }
            }
          `;
      const listCountrys = `
            query ListCountrys(
              $limit: Int
            ) {
              listCountrys(limit: $limit) {
                items {
                  code
                  name
                }
              }
            }
          `;
      const listStates = `
            query ListStates(
              $limit: Int
            ) {
              listStates(limit: $limit) {
                items {
                  name
                  abbreviation
                }
              }
            }
          `;

      const getMerchantForm = `
            query GetMerchantForm($params: QueryGetMerchantFormParamsInput!) {
              getMerchantForm(params: $params) {
                formElements {
                  formElement
                }
              }
            }
          `;

      const getMerchantFormParams = {
        merchant_code: tenantAlias
      };

      API.graphql({
        ...graphqlOperation(listCardTypes, { tenantAlias }),
        authMode: this.authMode
      })
        .then(result => {
          vm.lists.cardTypes = result.data.getAcquirerCardTypesByMerchant
            .map(c => {
              return { value: c.name, text: c.longName };
            })
            .sort(vm.sortSelectListByText);
          this.retrieveCardTypeValidationFromList(vm.lists.cardTypes);
        })
        .catch(e => {
          vm.$logger.error("Error getting card types");
          vm.$logger.error(e);
          vm.lists.cardTypes.push({
            value: "MC",
            text: "Master Card"
          });
          vm.lists.cardTypes.push({
            value: "Visa",
            text: "Visa"
          });
        });

      API.graphql({
        ...graphqlOperation(listCountrys, { limit: 300 }),
        authMode: this.authMode
      })
        .then(result => {
          vm.lists.countries = result.data.listCountrys.items
            .map(c => {
              return { value: c.code, text: c.name };
            })
            .sort(vm.sortSelectListByText);
        })
        .catch(e => {
          vm.$logger.error("Error getting countries");
          vm.$logger.error(e);
          vm.lists.countries.push({
            value: "388",
            text: "Jamaica"
          });
        });

      API.graphql({
        ...graphqlOperation(listStates, { limit: 60 }),
        authMode: this.authMode
      })
        .then(result => {
          vm.lists.states = vm.lists.states.concat(
            result.data.listStates.items
              .map(c => {
                return { value: c.abbreviation, text: c.name };
              })
              .sort(vm.sortSelectListByText)
          );
        })
        .catch(e => {
          vm.$logger.error("Error getting states");
          vm.$logger.error(e);
        });
      API.graphql({
        ...graphqlOperation(getMerchantForm, {
          params: getMerchantFormParams
        }),
        authMode: this.authMode
      })
        .then(c => {
          try {
            if (!c.data.getMerchantForm) return;
            this.customFields = c.data.getMerchantForm.formElements.map(
              this.renderCustomFields
            );
          } catch (e) {
            vm.$logger.error("Error parsing merchant form");
            this.$logger.error(e);
          }
        })
        .catch(e => {
          vm.$logger.error("Error getting merchant form");
          this.$logger.error(e);
        });
    },
    sortSelectListByText(c1, c2) {
      let a = c1.text.toUpperCase();
      let b = c2.text.toUpperCase();

      if (a > b) return 1;
      if (a < b) return -1;

      return 0;
    },
    renderCustomFields(e) {
      return JSON.parse(e.formElement);
    },
    clearFormConfigOnVuex() {
      this.$store.dispatch(CLEAR_PAYMENT_CONFIG);
    },
    clearTransactionError() {
      this.$store.dispatch(CLEAR_TRANSACTION_ERROR);
    },
    clearCommingFromReceiptPage() {
      this.$store.dispatch(SET_COMING_FROM_RECEIPT_PAGE_TO_FALSE);
    },
    getTransactionError() {
      this.pageConfig.transactionError = this.transactionErrorConfig;
      this.clearTransactionError();
      this.clearCommingFromReceiptPage();
    },
    setFieldData(data) {
      this.paymentConfig.merchantId = data.tenantAlias;
      this.paymentConfig.returnToMerchantUrl = data.merchantReturnUrl;
      this.setOrderInformation(data.orderInformation);
      this.setOrderDetails(data.orderDetails);
      this.setRecurringInformation(data.recurringInformation);
      this.clearFormConfigOnVuex();
      this.stopLoadingDialog();
      this.showSection(SECTION.PAYMENTFORM);
    },
    setOrderInformation(orderInfo) {
      this.handleZone(orderInfo.orderNumber);
      this.form.orderInformation.orderNumber = orderInfo.orderNumber;
      this.form.orderInformation.firstName = orderInfo.firstName;
      this.form.orderInformation.lastName = orderInfo.lastName;
      this.form.orderInformation.email = orderInfo.email;
      this.pageConfig.orderInformationReadOnly = true;
    },
    setOrderDetails(orderDetails) {
      this.form.orderDetails.amount = orderDetails.amount;
      this.form.orderDetails.initialPaymentAmount =
        orderDetails.initialPaymentAmount;
      this.form.orderDetails.currency = orderDetails.currency;
    },
    setRecurringInformation(recurringInfo) {
      this.form.recurringInformation.period = recurringInfo.period;
      this.form.recurringInformation.frequency = recurringInfo.frequency;
      this.form.recurringInformation.executionDate =
        recurringInfo.executionDate;
      this.form.recurringInformation.reason = recurringInfo.reason;
    },
    handleZone(orderNumber) {
      if (!orderNumber) return;
      const zone = extractZoneFromOrderNumber(
        this.paymentConfig.merchantId,
        orderNumber
      );
      this.paymentConfig.zone = zone;
    },
    async modifyPaymentIntentDiscounts(discounts) {
      const modifyPaymentIntentDiscount = `
            mutation ModifyPaymentIntent(
              $body: MutationModifyPaymentIntentBodyInput
            ) {
              modifyPaymentIntent(body: $body) {
                finalAmount,
                status
              }
            }
          `;
      const tenantAlias = this.paymentConfig.merchantId;
      const intentId = this.paymentConfig.intentId;
      discounts = !discounts ? [] : discounts;

      const modifyIntent = {
        tenantAlias,
        intentId,
        discounts
      };

      try {
        const modifyIntentResponse = await API.graphql({
          ...graphqlOperation(modifyPaymentIntentDiscount, {
            body: modifyIntent
          }),
          authMode: this.authMode
        });

        const finalAmount =
          modifyIntentResponse.data.modifyPaymentIntent.finalAmount;
        if (parseToFloat(finalAmount) !== this.finalAmount)
          throw new Error("Final Amounts do not match");
        const status = modifyIntentResponse.data.modifyPaymentIntent.status;

        return status;
      } catch (e) {
        this.$logger.error(e);
      }
      return false;
    },
    async retrieveRecurringInfo(intentId) {
      const getRecurringPaymentRequest = `
            query {
              getRecurringPaymentRequest(paymentRequestId: "${intentId}") {
                success
                error
                tenantAlias
                merchantReturnUrl
                orderInformation {
                  firstName
                  lastName
                  email
                  orderNumber
                }
                orderDetails {
                  amount
                  currency
                  initialPaymentAmount
                }
                recurringInformation {
                  period
                  frequency
                  executionDate
                  reason
                }
              }
            }
          `;
      const getRecurringPaymentRequestResponse = await API.graphql({
        ...graphqlOperation(getRecurringPaymentRequest),
        authMode: this.authMode
      });
      return getRecurringPaymentRequestResponse.data.getRecurringPaymentRequest;
    },
    handleRecurringResponse(response) {
      if (response.success) {
        this.setFieldData(response);
        this.$nextTick().then(() => {
          this.retrieveBanner();
          this.loadSelectLists();
        });
      } else {
        this.handleRecurringResponseError(response.error);
      }
    },
    handleRecurringResponseError(error) {
      this.$logger.error(error);
      this.stopLoadingDialog();
      const errorTitle = "Payment Information load error";
      const errorDescription = error;
      this.pageConfig.transactionError = {
        errorTitle,
        errorDescription
      };
      this.sectionDisplay.showPaymentForm = false;
      this.pageConfig.paymentErrorDismissible = false;
    }
  },
  async created() {
    this.startLoadingDialog("Loading Payment Information");
    this.paymentConfig.intentId = this.$route.params.id;
    if (!this.paymentConfig.intentId) this.$router.push({ name: "404" });
    this.getTransactionError();
    try {
      const response = await this.retrieveRecurringInfo(
        this.paymentConfig.intentId
      );
      this.handleRecurringResponse(response);
    } catch (err) {
      this.$logger.error(err);
      await this.stopLoadingDialog(
        "There was an error loading the page.",
        AlertModal.ERROR
      );
      this.$router.push({ name: "404" });
    }
  },
  async mounted() {
    this.lists.currencies = await this.retrieveEnabledCurrenciesOnly();
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Recurring Payment" }]);
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/pages/wizard/wizard-2.scss";
* {
  font-family: "Open Sans", sans-serif;
}

.kt-portlet {
  box-sizing: border-box;
  border: 1px solid #d8d8e4;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 8px 16px 0 rgb(49 51 80 / 20%);
}
.kt-portlet__foot {
  border-top: none !important;
  padding-top: 0px !important;
}
.kt-header {
  border-bottom: none !important;
}
.v-input {
  padding: 0;
}

.pay_img {
  max-width: 50% !important;
  width: 50% !important;
}

.img_container {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
